






























































































































































































































































import { defineComponent, toRefs, watch, ref, computed } from '@vue/composition-api';
import {
  HelpCircleIcon,
  ErrorCircleFilledIcon,
  CloseCircleFilledIcon,
  SearchIcon,
  LoadingIcon,
  DownloadIcon,
} from 'tdesign-icons-vue';
import dayjs from 'dayjs';
import Chart from '@/renderer/components/charts/Chart.vue';

import { setResizableColumns } from '@/renderer/scripts/composition/tableResizeHandler';
import { getNameTipsDetail } from '@/renderer/scripts/utils/tools';
import { i18n_t } from '@/locales/i18n';
import trafficHandler from './compositions/trafficHandler';
import listHandler from '../listHandler';
import { upgradeName, goUpgrade } from '../statisticsHandler';
export default defineComponent({
  components: {
    HelpCircleIcon,
    ErrorCircleFilledIcon,
    CloseCircleFilledIcon,
    SearchIcon,
    LoadingIcon,
    DownloadIcon,
    Chart,
  },
  setup(props, context) {
    const store = context.root.$store;
    const {
      purchaseTrafficInfo,
      freeTrafficInfo,
      timing,
      disabledDate,
      timeRange,
      startTime,
      endTime,
      chartLoading,
      chartOptions,
      methods: handlerMethods,
    } = trafficHandler();
    const {
      tabValue,
      columns,
      tableData,
      defaultSort,
      isExporting,
      sort,
      methods: listMethods,
    } = listHandler('traffic');

    const resizeColumns = computed(() => setResizableColumns(columns.value));

    const placeholderText = computed(() =>
      tabValue.value === 'teamSpace'
        ? i18n_t('请输入团队名称搜索团队')
        : i18n_t('请输入用户昵称{slot1}搜索用户', {
            slot1: !store.getters.allowPhoneLogin ? '' : i18n_t('/手机号'),
          }),
    );

    handlerMethods.trafficUsageOverview();
    listMethods.pullList();
    handlerMethods.trafficUsageTiming();
    watch(timing, val => {
      handlerMethods.getTimeRange(val);
      handlerMethods.trafficUsageTiming();
    });
    watch(timeRange, val => {
      startTime.value = dayjs(val[0]).format('YYYY-MM-DD 00:00:00');
      endTime.value = dayjs(val[1]).format('YYYY-MM-DD 23:59:59');
      handlerMethods.trafficUsageTiming();
    });
    reporter.report('value_added', {
      flow_show: 'management_center_flow_button',
    });
    return {
      tabValue,
      timing,
      disabledDate,
      timeRange,
      upgradeName,
      sort,
      purchaseTrafficInfo,
      freeTrafficInfo,
      isExporting,
      resizeColumns,
      placeholderText,
      ...toRefs(tableData),
      defaultSort,
      chartLoading,
      chartOptions,
      handlerMethods,
      listMethods,
      goUpgrade,
      getNameTipsDetail,
    };
  },
});
